import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AngularEditorConfig } from "@kolkov/angular-editor";

@Component({
  selector: "app-add-announcement-dialog",

  templateUrl: "./add-announcement-dialog.component.html",
  styleUrls: ["./add-announcement-dialog.component.scss"],
})
export class AddAnnouncementDialogComponent implements OnInit {
  form;
  fileName;
  message;
  originalMessage;
  hasFileChanged = false;
  isMessageChanges = false;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: false,
    translate: "no",
    height: "auto",
    minHeight: "100px",
    maxHeight: "auto",
    width: "auto",
    minWidth: "0",
    enableToolbar: true,
    showToolbar: true,
    placeholder: "Comentario...",
    defaultParagraphSeparator: "p",
    fonts: [
      { class: "arial", name: "Arial" },
      { class: "times-new-roman", name: "Times New Roman" },
      { class: "calibri", name: "Calibri" },
      { class: "comic-sans-ms", name: "Comic Sans MS" },
    ],
    sanitize: false,
    toolbarPosition: "bottom",
    toolbarHiddenButtons: [
      ["insertImage", "insertVideo"],
      ["toggleEditorMode"],
    ],
  };

  constructor(
    public dialogRef: MatDialogRef<AddAnnouncementDialogComponent>,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.data?.announcementDetail?.message) {
      this.message = this.data.announcementDetail.message;
    }
    if (this.data?.announcementDetail?.filename) {
      this.fileName = this.data.announcementDetail.filename;
    }

    this.form = this.formBuilder.group({
      message: ["", [Validators.required]],
      file: [""],
    });
  }

  onSubmit() {
    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();

    if (this.form.valid) {
      let file = this.form.get("file").value || "";
      let message = this.form.get("message").value;
      let filename = file !== "" ? this.fileName : "";

      var objForm: any = {
        file: file,
        message: message,
        filename: filename,
      };

      this.dialogRef.close(objForm);
    }
  }

  cancel() {
    localStorage.removeItem("originalMessage");
    localStorage.removeItem("originalFileName");
    this.dialogRef.close({ event: "Cancel" });
  }

  setFileName(fileName) {
    this.hasFileChanged = true;
    this.fileName = fileName;
  }

  messageChanged(value) {
    if (localStorage.getItem("originalMessage").trim() == value.trim()) {
      return false;
    } else {
      return true;
    }
  }

  fileChanged() {
    let originalFileName =
      localStorage.getItem("originalFileName") == "null"
        ? ""
        : localStorage.getItem("originalFileName");
    let currentFileName = this.form.get("file").value ? this.fileName : "";

    if (originalFileName.trim() == currentFileName.trim()) {
      return false;
    } else {
      return true;
    }
  }

  getInvoiceCodes(invoice): string {
    const codes = invoice.physicalInvoices.map((inv) => inv.code) || [];
    return codes.join(", ");
  }

  getInvoiceCodesCount(invoice): number {
    const codes = invoice.physicalInvoices.map((inv) => inv.code) || [];
    return codes.length;
  }
}
